<script>
  import { ignore } from "../../Common/tools";
  import SimpleLinkPicker from "../../Common/SimpleLinkPicker.svelte";
  import QuizResultMessageSettings from "./QuizResultMessageSettings.svelte";
  import {External, M} from "../../external";

  export let widget,
    onChange = ignore;

  let data = widget.data,
    widgetUi = widget.$widget;

  let resultRules = (data.resultType === "page" ? data.resultPages : data.resultMessages) || [];

  let selectTags = (idx) => {
    let rule = Object.assign({}, data.resultType === "page" ? data.resultPages[idx] : data.resultMessages[idx]);

    let tags = rule.tags || [];
    let selectedTags = [];
    for (let idx = 0; idx < tags.length; ++idx) {
      for (let tagIdx = 0; tagIdx < External.Website.crmTags.length; ++tagIdx) {
        if (External.Website.crmTags[tagIdx].label === tags[idx]) {
          selectedTags.push(External.Website.crmTags[tagIdx]);
          break;
        }
      }
    }

    External.UITools.selectTags(
      selectedTags,
      (newTags) => {
        rule.tags = newTags.map((tag) => tag.label);
        if (data.resultType === "page") {
          data.resultPages[idx] = rule;
        } else {
          data.resultMessages[idx] = rule;
        }
        onChange();
      },
      true
    );
  };

  let editMessageRule = (idx) => {
    let rule = Object.assign({}, data.resultMessages[idx]);

    External.Tools.showWindow({
      isModal: false,
      title: M.EDIT_THANK_YOU_MESSAGE,
      icon: External.Popup.ICON_ADD,
      width: 400,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      markup: "",
      action: {
        onShow: (popup, ui) => {
          new QuizResultMessageSettings({
            target: popup.getContentArea(),
            props: {
              message: rule
            }
          });
        }
      },
      buttons: [
        External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup, context) {
          data.resultMessages[idx] = rule;
          onChange();
          popup.close();
        }),
        External.Button.MIDDLE_CANCEL
      ]
    });
  };

  let deleteMessageRule = (idx) => {
    if (data.resultType === "page") {
      data.resultPages.splice(idx, 1);
    } else {
      data.resultMessages.splice(idx, 1);
    }
    resultRules = data.resultType === "page" ? data.resultPages : data.resultMessages;
    onChange();
  };

  let addResultsRule = () => {
    let nextStep = External.Website && External.Website.getActiveFunnelStep() === null ? "" : "javascript:WebPlatform.Funnels.show('next')";
    if (data.resultType === "page") {
      resultRules.push({
        from: 0,
        to: 100,
        url: nextStep
      });
      data.resultPages = resultRules;
    } else {
      resultRules.push({
        from: 0,
        to: 100,
        title: "",
        description: "",
        withCTA: false,
        ctaText: M.NEXT,
        ctaTarget: nextStep
      });
      data.resultMessages = resultRules;
    }
    resultRules = resultRules;
    onChange();
  };

  let setResultType = (type) => {
    data.resultType = type;
    resultRules = data.resultType === "page" ? data.resultPages : data.resultMessages;
    onChange();
  };
</script>

<div class="popup-widget-wrapper form-admin-style-2">
  <div class="help-text-wrapper">
    <span class="help-text" style="margin-bottom:15px;">
      {M.FORM_RESULTS_DESC}
    </span>
  </div>
  <ul class="option-select">
    <li class:active={data.resultType === "page"}>
      <a class="one-step-form transition-bg" on:click={() => setResultType("page")}>
        <span style="margin-bottom:12px;" />
        {M.PAGE_REDIRECT}
      </a>
    </li>
    <li class:active={data.resultType !== "page"}>
      <a class="multi-step-form transition-bg" on:click={() => setResultType("message")}>
        <span style="margin-bottom:12px;" />
        {M.THANK_YOU_MESSAGE}
      </a>
    </li>
  </ul>
  <div class="help-text-wrapper">
    <span class="help-text" style="margin-bottom:15px;">
      {M.FORM_RESULTS_INFO}
    </span>
  </div>
  <div class="col20 f-left mt-10">
    {#each resultRules as rule, idx (rule)}
      <div class="result-row f-left col20 flex align-center">
        <span class="flex-none">{M.FROM_RANGE}</span>
        <input class="flex-none mt-5" style="width: 70px; margin-top: 5px" type="number" step="1" bind:value={rule.from} on:change={onChange} />
        <span class="flex-none">{M.TO_RANGE}</span>
        <input class="flex-none mt-5" style="width: 70px; margin-top: 5px" type="number" step="1" bind:value={rule.to} on:change={onChange} />
        {#if data.resultType === "page"}
          <div class="flex-1 ml-15">
            <SimpleLinkPicker bind:link={rule.url} onChange={onChange} />
          </div>
        {:else}
          <div class="flex-1 ml-15">
            <input type="text" readonly value={rule.title} on:click={() => editMessageRule(idx)} />
          </div>
          <a data-tooltip="settings" class="ml-10 flex-none button-tooltip" on:click={() => editMessageRule(idx)}>
            <i class="material-icons-outlined">settings</i>
          </a>
        {/if}
        <a data-tooltip={M.ADD_TAGS} class="ml-10 flex-none button-tooltip" on:click={() => selectTags(idx)}>
          <i class="material-icons-outlined">label</i>
        </a>
        <a data-tooltip="simpleDelete" class="ml-10 flex-none button-tooltip" on:click={() => deleteMessageRule(idx)}>
          <i class="material-icons-outlined">delete</i>
        </a>
      </div>
    {/each}
    <div class="col20 f-left mt-15">
      <a class="blue middle-button with-icon" on:click={addResultsRule}>
        {M.ADD_RULE}
      </a>
    </div>
  </div>
</div>
